/* istanbul ignore file */
// TODO: Create test file
// TODO: simply reactivity - needs exploration

import { computed, inject } from 'vue';

import useBrandData from './useBrandData';
import useSpecialtylData from './useSpecialtyData';

export default function useContextualData() {
  const isVirtualAdvisor = inject('isVirtualAdvisor');

  const { photoName: brandPhotoName, fullCopy: brandFullCopy, storeFrontUrl } = useBrandData() || {};
  const isBrandData = computed(() => !!storeFrontUrl?.value);

  const { photoName: specialtyPhotoName, fullCopy: specialtyFullCopy, specialtyId } = useSpecialtylData() || {};
  const validateSpecialtyData = computed(() => (isVirtualAdvisor?.value ? !!specialtyFullCopy.value : !!specialtyId?.value));
  const isSpecialtyData = computed(() => !!(
    !isBrandData.value && validateSpecialtyData.value
  ));

  return {
    isBrandData,
    isSpecialtyData,
    storeFrontUrl,
    specialtyId,
    photoName: computed(() => (isBrandData.value ? brandPhotoName.value : (isSpecialtyData.value && specialtyPhotoName.value)) || ''),
    fullCopy: computed(() => (isBrandData.value ? brandFullCopy.value : (isSpecialtyData.value && specialtyFullCopy.value)) || ''),
  };
}
